<div class="col-md-12 mb-30" [hidden]="Selected_Schedule_Record.id>0 || FormTypeShow!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Manager Schedule List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Customer Name</label>
          <input [(ngModel)]="Filter_customerName" (keyup)="Change_Filter_title()" name="Filter_customerName" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="Filter_letterCode" (keyup)="Change_Filter_title()" name="Filter_letterCode" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Full Name</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Schedule()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Request ID</th>
              <th>Full Name</th>
              <th>Mission Time</th>
              <th>Letter Number</th>
              <th>Customer Name</th>

              <th>Registration Time</th>
              <th>Workflow</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_Schedule
                  |filter:Filter_letterCode:'letterCode'
                  |filter:Filter_customerName:'customerName'
                  |filter:Filter_title:'fullname'
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 50,
                              currentPage: page,
                              totalItems: (DataList_Schedule
                              |filter:Filter_letterCode:'letterCode'
                                          |filter:Filter_customerName:'customerName'
                                          |filter:Filter_title:'fullname'
                                        ).length
                            }">

              <tr>
                <td>{{DataList_Schedule.indexOf(item)+1}}</td>
                <td>{{item.id}}</td>
                <td>{{item.fullname}}</td>
                <td>{{item.persianDate}} from {{item.startDate}} to {{item.endDate}}</td>

                <td>{{item.letterCode}}</td>
                <td>{{item.customerName}}</td>


                <td>{{item.persianDate2}}</td>
                <td>{{item.flowchart.flochart_title}}</td>
                <td>
                  <p *ngIf="item.statusStr==1" style="color: rgb(20, 77, 220);">Under Review</p>
                  <p *ngIf="item.statusStr==2" style="color: #489b39;">Approve</p>
                  <p *ngIf="item.statusStr==3" style="color: crimson;">Reject</p>
                </td>

                <td rowspan="2">
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" *ngIf="!item.sms" (click)="ReadData_Form(item)"
                          class="dropdown-item"><i class="fa fa-eye"></i> View </a>
                        <a style="cursor: pointer;" *ngIf="item.sms" (click)="ReadData_Form(item)"
                          class="dropdown-item"><i class="fa fa-eye"></i> Hide </a>
                        <a *ngIf="item.status==2" style="cursor: pointer;" (click)="ReadData_View(item)"
                          class="dropdown-item"><i class="fa fa-leanpub"></i> Revision
                        </a>
                        <a href="{{BaseUrl1}}{{item.flowchart.flochart_id}}{{BaseUrlCo}}{{item.flowchart.makerId}}"
                          target="_blank" class="dropdown-item"><i class="fa fa-wpbeginner"></i>
                          Workflow
                        </a>
                        <a style="cursor: pointer;" (click)="ReadData_History(item)" class="dropdown-item"><i
                            class="fa fa-history"></i>
                          Workflow History
                        </a>

                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th colspan="2">Description</th>
                <td colspan="7">{{item.dsc}}</td>
              </tr>
              <tr *ngIf="item.sms">
                <td colspan="7">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #396c9b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Last Name</th>
                        <th>National ID</th>
                        <th>Mobile Number</th>
                        <th>Father Name</th>
                        <th>Supervisor</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let detail of item.expert">
                        <td>{{item.expert.indexOf(detail)+1}}</td>
                        <td>{{detail.name}}</td>
                        <td>{{detail.familly}}</td>
                        <td>{{detail.melicode}}</td>
                        <td>{{detail.shomareh_Hamreh}}</td>
                        <td>{{detail.name_Pedar}}</td>
                        <td>
                          <p *ngIf="detail.seleted">Yes</p>
                          <p *ngIf="!detail.seleted">No</p>
                        </td>

                      </tr>
                    </tbody>
                  </table>

                </td>
              </tr>

            </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<div *ngIf="FormTypeShow=='History'" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Request Workflow History '{{Selected_Schedule_Record.flowchart.uniCode}}'
          </h5>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-FlowchartHistory [DataList_History]="DataList_History"></app-FlowchartHistory>
          </div>

        </div>


      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>
  </div>

</div>
